import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompaniesService } from '../../../../features/companies/services/companies.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-withdraw-details',
  templateUrl: './withdraw-details.component.html',
  styles: ``
})
export class WithdrawDetailsComponent {
  @Output() close = new EventEmitter(false);
  @Output() RequestChanged = new EventEmitter(false);
  @Input() selectedRequestId!: any;
  @Input() Permissions!: any;
  dataLoading: boolean = false;
  RequestDetailes: any
  constructor(private _dialog: MatDialog, private _companyService: CompaniesService) {

  }


  ngOnInit(): void {
  }

  ngOnChanges(changes: any): void {
    if (this.selectedRequestId) {
      this.OnGetRequestDetailes()
    }
  }


  // OnApproveRequest() {
  //   const dialogRef = this._dialog.open(ApproveWithdrawalRequestComponent, {
  //     width: '540px',
  //     data: this.selectedRequestId
  //   })

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       this.OnGetRequestDetailes()
  //       this.RequestChanged.emit(true);
  //     }
  //   })
  // }

  // OnDeclineRequest() {
  //   const dialogRef = this._dialog.open(DeclineWithdrawalRequestComponent, {
  //     width: '540px',
  //     data: this.selectedRequestId
  //   })

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       this.OnGetRequestDetailes()
  //       this.RequestChanged.emit(true);
  //     }
  //   })
  // }


  OnGetRequestDetailes() {
    this.dataLoading = true;
    // let model = { request_id: this.selectedRequestId }
    this._companyService.GetWithdrawalRequestById(this.selectedRequestId).subscribe({
      next: (res: any) => {
        this.dataLoading = false;
        this.RequestDetailes = res.data;
      },
      error: (err: any) => {
        this.dataLoading = false;
      }
    });
  }


}
